import React from 'react';
import { DemoTemplate } from 'src/templates';

import { TransferDemo } from 'src/components/TransferDemo';

const metaData = {
  layout: 'demo',
  'meta-title': 'Plaid Instant Payouts',
  'meta-description': 'Explore Plaid Instant Payouts',
};

export default () => {
  return (
    <DemoTemplate {...metaData}>
      <TransferDemo />
    </DemoTemplate>
  );
};
